/**
 * LinkedIn Insight Tag loader, gated on its own consent choice.
 *
 * The tag fires once per page load for retargeting; it does not need to be
 * re-triggered on client-side route changes.
 */
import { ANALYTICS_ENABLED, LINKEDIN_PARTNER_ID, LINKEDIN_SRC } from './config';

let scriptInjected = false;

export function bootLinkedIn(state) {
    if (!ANALYTICS_ENABLED || !state.linkedinInsight || scriptInjected) return;

    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    if (!window._linkedin_data_partner_ids.includes(LINKEDIN_PARTNER_ID)) {
        window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = LINKEDIN_SRC;
    document.head.appendChild(script);
    scriptInjected = true;
}
